export default "__VITE_ASSET__4c9cc2e5__"